<template>
	<div>
		<StateBar class="w-50p" />
		<h2 class="fs-title text-center">Szerződés adatai</h2>
		<ValidationObserver ref="form" v-slot="{ invalid }">
			<ContractQuestions />
			<form @submit.prevent="next" v-show="lastStep && isActive">
				<CalcElements :elements="elements" />
			</form>
			<NavButtons :prevLink="prevLink" :nextLink="nextLink" @next="next" @prev="onPrev" :disabled="!lastStep"/>
		</ValidationObserver>
	</div>
</template>

<script>
import ContractDetails from '@json/ContractDetails.json';
import CalcElements from '@/components/CalcElements';
import Insurers from '@json/Insurers.json';
import MfoInsurers from '@json/MfoInsurers.json';
import ContractQuestions from '@/components/ContractQuestions';
import NavButtons from '@/components/NavButtons';
import validation from '@/mixins/validation';
import { mapGetters } from 'vuex';
import {cloneDeep} from "lodash";
import moment from "moment/moment";

export default {
	mixins: [validation],
	data() {
		return {
			nextLink: 'package-information',
		};
	},
	computed: {
		...mapGetters(['getQuestionAnswers']),
		getCheckboxData() {
			return key => this.getQuestionAnswers[key] ?? null;
		},
        lastStep() {
            return this.getCheckboxData('isNewContract') || this.getCheckboxData("oldContractLastStep");
        },
		isActive() {
			return this.getCheckboxData('isNewContract') || (this.$store.state.questionAnswers?.bondNumber != null && ((this.$store.state.questionAnswers?.isMfo && typeof MfoInsurers[this.$store.state.questionAnswers?.insurer] !== "undefined" ) || (!this.$store.state.questionAnswers?.isMfo && typeof Insurers[this.$store.state.questionAnswers?.insurer] !== "undefined" )) && (this.diffStartOfRisk > 30 || (this.diffStartOfRisk < 31 && this.$store.state.onMyOwn)));
		},
        diffStartOfRisk() {
            const startOfRisk = moment(this.$store.state.questionAnswers.startOfRisk);
            return startOfRisk.diff(moment(), 'days');
        },
		prevLink() {
			return this.hasMovables ? 'movable' : 'property-details';
		},
        elements() {
            const data = cloneDeep(ContractDetails);
            delete data.groupElements1.elements.start_of_risk.fromDateAttr;
            if(!this.getCheckboxData('isNewContract')) {
              data.groupElements1.elements.start_of_risk.fromDateAttr = "questionAnswers.startOfRisk";
            }
            return data;
        },
	},
    methods:{
        next() {
            if(this.lastStep) {
                this.onSubmit();
            }
        }
    },
	components: {
		CalcElements,
		NavButtons,
		ContractQuestions,
	},
};
</script>
